// DrawerNavigation.js

import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { categories } from "../constant";

const DrawerNavigation = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [dropdowns, setDropdowns] = useState({
    services: false,
    products: false,
  });
  const navigate = useNavigate();

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const toggleDropdown = (dropdownName) => {
    setDropdowns((prevDropdowns) => ({
      // ...prevDropdowns,
      [dropdownName]: !prevDropdowns[dropdownName],
    }));
  };
  const handler = (link) => {
    setIsDrawerOpen(false);
    navigate(link);
    // window.location.href = link;
  };
  return (
    <div className="flex">
      {/* Drawer Toggle Button */}
      <button
        className="w-[20px] p-4  focus:outline-none text-black text-2xl transition duration-300"
        onClick={toggleDrawer}
      >
        ☰
      </button>

      {/* Drawer Overlay */}
      <div
        className={`fixed inset-0 bg-white bg-opacity-50 z-50 ${isDrawerOpen ? "visible" : "hidden"
          }`}
        onClick={toggleDrawer}
      ></div>

      {/* Drawer Content */}
      <div
        className={`fixed left-0 top-0 min-h-screen    z-50 bg-white text-balck w-72  transform transition-transform ease-in-out ${isDrawerOpen ? "translate-x-0" : "-translate-x-full"
          }`}
      >
        <button
          onClick={() => setIsDrawerOpen(false)}
          className="float-right m-5"
        >
          <AiOutlineClose size={30} color="gray" />
        </button>
        <nav className="p-4 h-full ">
          {/* Your navigation links go here */}
          <ul>
            <li>
              <button
                onClick={() => {}}
                className="block py-2 px-4 bg-white w-full text-left"
              >
                Home
              </button>
            </li>
            {
              categories.map(cat => (
                <li key={cat.name}>
                  <button
                    onClick={() => toggleDropdown(cat.name)}
                    className="block py-2 px-4 bg-white w-full text-left"
                  >
                    {cat.name}
                  </button>
                  {dropdowns[cat.name] &&
                    cat.subcategories?.filter(sub => sub.id)
                      .map((sub) => (
                        <ul className="ml-8 mt-2">
                          <li>
                            <button
                              onClick={() => {}}
                              className="block p-2 hover:bg-slate-100"
                            >
                              {sub.name}
                            </button>
                          </li>
                        </ul>
                      ))
                  }
                </li>
              ))
            }
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default DrawerNavigation;
